<div class="partner-store-employee-body">
    <!--Body Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>
    <!--Table header-->
    <div class="flex flex-row" style="padding: 15px 0px; align-items: center;">
        <div class="partner-store-empl-text">Employees assigned to the store <a style="font-size: 18px; font-weight: 600; margin-left: 15px;">{{totalRecords}} Employees</a></div>
        <div style="margin-left: auto; margin-right: 18px;">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="search-input" style="width: 280px"
                       [(ngModel)]="searchName" (input)="handleFilterChange()"
                       placeholder="Search Employee..." />
            </span>
        </div>
        <div>
            <button pButton pRipple class="btn-darkblue" style="height: 42px" [label]="'Create Employee'" icon="pi pi-plus" (click)="op.toggle($event)"></button>
            <p-overlayPanel #op [style]="{width: '180px'}">
                <ng-template pTemplate>
                    <button (click)="handleShowCreateEmployee(menuTab.StoreEmployees)" pButton type="button" label="Store Employee" class="p-button-text"></button>
                    <button (click)="handleShowCreateEmployee(menuTab.WebAdmins)" pButton type="button" label="Web Admins" class="p-button-text"></button>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>

    <!--table-->
    <div style="height: calc(100vh - 300px)">
        <p-table #storeEmployeesGrid
                 [columns]="cols"
                 [value]="storeEmployees"
                 [lazy]="true"
                 [loading]="loading"
                 responsiveLayout="scroll" dataKey="UserId"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [(selection)]="selectedUsers"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-striped'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressUser>
                <tr [pSelectableRow]="xpressUser">
                    <td class="ui-resizable-column">{{xpressUser.UserId}}</td>
                    <td class="ui-resizable-column">{{xpressUser.CreatedAt}}</td>
                    <td class="ui-resizable-column">{{xpressUser.UserName}}</td>
                    <td class="ui-resizable-column">{{xpressUser.RoleName}}</td>
                    <td class="ui-resizable-column">{{xpressUser.Store.Name}} | {{xpressUser.Store.Address}} {{xpressUser.Store.AddressDetails}}</td>
                    <td>
                        <span class="action-icon-svg" (click)="handlePopupLinkClick(xpressUser, false)">
                            <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                        </span>
                        <!--<span class="action-icon-svg" (click)="handlePopupLinkClick(xpressUser, true)">
                            <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                        </span>-->
                        <span class="action-icon-svg" (click)="deleteMerchantUser(xpressUser.UserId)">
                            <img src="../Content/xpress-app/images/svg/icon_suspend.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="storeEmployees.length > 0" class="partner-store-empl-tab-footer">
                    Showing {{first + 1}} to {{first + storeEmployees.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
<create-merchant-employee [visible]="showCreateEmployee" [typeCreatedEmployee]="typeCreatedEmployee" [showEditFields]="showEditFields"
                          [onHide]="handleCreatePopupHide" [merchantId]="merchantId" [employee]="selectedUser" [isCreateEmployee]="isCreateEmployee"></create-merchant-employee>
<p-toast position="top-right"></p-toast>
